import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { type TaskIdentifierDto, UserShortDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  description: string;
  subject: string;
};

type Response = TaskIdentifierDto;

type Return = {
  isSubmitting: boolean;
  submitFeedback: (req: Req) => Promise<Response>;
};

export const useSubmitFeedback = (): Return => {
  const { tasksApi } = useApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      const users = queryClient.getQueryData<UserShortDto[]>([QueryKeyEnum.USERS.SHORT]);
      const taskUser = users?.find(user => user.lastName === 'Maj' && user.firstName === 'Robert');
      if (!taskUser) {
        throw new Error('No user found');
      }
      const { data } = await tasksApi.createTask({
        assignedUserId: taskUser.userId,
        contextResourceId: taskUser.userId,
        contextResourceType: 'INCIDENT_TICKET',
        creatorUserId: taskUser.userId,
        description: req.description,
        dueDate: dayjs().add(1, 'day').toISOString(),
        emailThreadId: undefined,
        hidden: true,
        status: 'NEW',
        title: req.subject,
        watchersUserIds: [],
      });
      return data;
    },
  });

  return {
    isSubmitting: isPending,
    submitFeedback: mutateAsync,
  };
};
